import React, { useState } from 'react';
import { API, authFetch } from '../utils/api';

// 경매 수정 모달 — title / description 2필드만
// 백엔드 PUT /api/auctions/:id 제약: 본인 + active + bid_count=0
function AuctionEditModal(props){
  var auction=props.auction||{};
  var onClose=props.onClose;
  var onSuccess=props.onSuccess;

  var initialTitle=auction.title||'';
  var initialDesc=auction.description||'';

  var[title,setTitle]=useState(initialTitle);
  var[description,setDescription]=useState(initialDesc);
  var[submitting,setSubmitting]=useState(false);
  var[error,setError]=useState('');

  var modelLabel=(auction.car&&auction.car.model)||auction.title||'경매 차량';
  var carNo=auction.car&&auction.car.number?auction.car.number:'';

  var parseMan=function(s){return parseInt(String(s||'').replace(/[^0-9]/g,''))||0};
  var formatMan=function(n){return n?Number(n).toLocaleString():''};

  var handleSubmit=function(){
    if(submitting)return;
    var trimTitle=(title||'').trim();
    if(!trimTitle){setError('제목을 입력해주세요');return}
    setSubmitting(true);
    setError('');
    var body={
      title:trimTitle,
      description:(description||'').trim()
    };
    authFetch(API+'/auctions/'+auction.id,{method:'PUT',body:JSON.stringify(body)})
      .then(function(r){return r.json()})
      .then(function(d){
        if(d&&d.success){
          if(onSuccess)onSuccess(d.data&&d.data.auction);
        }else{
          setError((d&&d.error)||'수정 실패');
        }
      })
      .catch(function(){setError('서버 연결 실패')})
      .then(function(){setSubmitting(false)});
  };

  var inputStyle={width:'100%',padding:'10px 12px',border:'1px solid #cbd5e1',borderRadius:6,fontSize:13,outline:'none',boxSizing:'border-box'};
  var labelStyle={display:'block',fontSize:11,fontWeight:700,color:'#64748b',marginBottom:6};

  return (
    <div onClick={function(){if(!submitting)onClose()}}
      style={{position:'fixed',inset:0,background:'rgba(15,23,42,0.6)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:9998,padding:16}}>
      <div onClick={function(e){e.stopPropagation()}}
        style={{background:'#fff',borderRadius:16,width:'100%',maxWidth:480,maxHeight:'90vh',display:'flex',flexDirection:'column',boxShadow:'0 20px 60px rgba(0,0,0,0.3)'}}>

        {/* 헤더 */}
        <div style={{padding:'16px 20px',borderBottom:'1px solid #e5e7eb',display:'flex',alignItems:'center',justifyContent:'space-between',flexShrink:0}}>
          <div style={{fontSize:16,fontWeight:800,color:'#1B3A5C',display:'flex',alignItems:'center',gap:6}}>
            <span>✏️</span><span>경매 수정</span>
          </div>
          <button onClick={onClose} disabled={submitting}
            style={{background:'none',border:'none',fontSize:20,cursor:submitting?'wait':'pointer',color:'#94a3b8',padding:4}}>✕</button>
        </div>

        {/* 본문 */}
        <div style={{flex:1,overflowY:'auto',padding:'18px 20px'}}>
          {/* 차량 요약 (읽기 전용) */}
          <div style={{padding:'10px 12px',background:'#f8fafc',borderRadius:8,marginBottom:16,fontSize:12,color:'#475569'}}>
            <div style={{fontSize:10,color:'#94a3b8',marginBottom:2}}>차량</div>
            <div style={{fontWeight:700,color:'#0f172a'}}>
              {carNo&&<span>{carNo} </span>}{modelLabel}
            </div>
          </div>

          {/* 안내 */}
          <div style={{padding:'10px 12px',background:'#fff7ed',border:'1px solid #fed7aa',borderRadius:8,fontSize:11,color:'#9a3412',lineHeight:1.6,marginBottom:14}}>
            ℹ️ 입찰이 없는 active 경매만 수정 가능 · 경매 기간은 수정할 수 없습니다
          </div>

          {/* 제목 */}
          <div style={{marginBottom:14}}>
            <label style={labelStyle}>경매 제목 <span style={{color:'#ef4444'}}>*</span></label>
            <input value={title} onChange={function(e){setTitle(e.target.value.substring(0,100));setError('')}}
              disabled={submitting}
              placeholder="예: 2024 그랜저 하이브리드 완전무사고"
              style={inputStyle}/>
          </div>

          {/* 설명 */}
          <div style={{marginBottom:14}}>
            <label style={labelStyle}>설명 (선택)</label>
            <textarea value={description} onChange={function(e){setDescription(e.target.value.substring(0,1000))}}
              disabled={submitting}
              placeholder="신차급 컨디션, 1인 소유 등..."
              style={Object.assign({},inputStyle,{minHeight:80,resize:'vertical',fontFamily:'inherit',lineHeight:1.5})}/>
          </div>

          {/* 에러 */}
          {error&&(
            <div style={{padding:'10px 12px',background:'#fef2f2',border:'1px solid #fecaca',borderRadius:8,fontSize:12,color:'#dc2626',marginBottom:12}}>
              {error}
            </div>
          )}
        </div>

        {/* 하단 액션 */}
        <div style={{padding:'14px 20px',borderTop:'1px solid #e5e7eb',flexShrink:0}}>
          <button onClick={handleSubmit} disabled={submitting||!title.trim()}
            style={{width:'100%',padding:'13px 0',background:(submitting||!title.trim())?'#cbd5e1':'#1B3A5C',color:'#fff',border:'none',borderRadius:8,fontSize:14,fontWeight:800,cursor:submitting?'wait':'pointer'}}>
            {submitting?'저장 중...':'✓ 수정 완료'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default AuctionEditModal;
